import { HealthcareFacilityUnitSimple } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import {
   addressFormatter,
   createTranslatedText,
   useInterpolatedTranslationKey,
   useTranslate,
} from '@dreryk/react-common';
import { AutoLayout, EditIcon, Tree } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';
import { HealthcareBasicData } from '../../../common/HealthcareBasicData';
import { HealthcareFacilityLocationTreeLeaves } from '../location/HealthcareFacilityLocationTreeLeaves';
import { StyledHealthcareTreeItemText } from '../StyledHealthcareTreeItemText';

import { HealthcareFacilityUnitUpdateLink } from './HealthcareFacilityUnitUpdateLink';

type HealthcareFacilityUnitTreeItemProps = {
   readonly healthcareFacilityUnit: HealthcareFacilityUnitSimple;
   readonly healthcareParentData: HealthcareBasicData;
   readonly onDataChanged: VoidFunction;
};

export const HealthcareFacilityUnitTreeItem = (props: HealthcareFacilityUnitTreeItemProps): JSX.Element => {
   const translate = useTranslate();
   const unitCode = useInterpolatedTranslationKey(healthcareOrganizationTranslationKeys.unitCode, {
      unitCode: props.healthcareFacilityUnit.unitCode,
   });
   const address = addressFormatter(props.healthcareFacilityUnit.address);

   return (
      <Tree.Item
         testId={`healthcareFacilityUnit-${props.healthcareFacilityUnit.id}`}
         content={
            <AutoLayout
               as={'div'}
               $horizontalResizing={'fill'}
               $spacingMode={'space-between'}
               $spacing={4}
               $alignement={'center'}
            >
               <AutoLayout as={'div'} $direction={'vertical'} $spacing={4}>
                  <StyledHealthcareTreeItemText testId={'unitCode'}>{translate(unitCode)}</StyledHealthcareTreeItemText>
                  <HealthcareFacilityUnitUpdateLink
                     testId={'name'}
                     label={createTranslatedText(props.healthcareFacilityUnit.name)}
                     healthcareFacilityUnitId={props.healthcareFacilityUnit.id}
                     healthcareParentData={props.healthcareParentData}
                     onDataChanged={props.onDataChanged}
                  />
                  {address ? (
                     <StyledHealthcareTreeItemText testId={'address'}>{address}</StyledHealthcareTreeItemText>
                  ) : null}
               </AutoLayout>

               <HealthcareFacilityUnitUpdateLink
                  testId={'healthcareFacilityUnitUpdate'}
                  icon={<EditIcon />}
                  healthcareFacilityUnitId={props.healthcareFacilityUnit.id}
                  healthcareParentData={props.healthcareParentData}
                  onDataChanged={props.onDataChanged}
               />
            </AutoLayout>
         }
      >
         <HealthcareFacilityLocationTreeLeaves healthcareParentData={props.healthcareFacilityUnit} />
      </Tree.Item>
   );
};
